import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import GoHome from "../components/post/GoHome";
import PostDetails from "../components/post/PostDetails";
import RelatedPost from "../components/post/RelatedPosts";
import { fetchPost } from "../features/post/postSlice";

export default function Post() {
  const { post } = useSelector(state => state.post)
  const dispatch = useDispatch();
  const { postId } = useParams();

  const { tags } = post || {};

  useEffect(() => {
    dispatch(fetchPost(postId));
  }, [dispatch, postId]);

  return (
    <>
      <GoHome />
      <section className="post-page-container">
        {
          <>
            {Object.entries(post).length && post.id ?
              <PostDetails post={post} />
              :
              <div>Post Not Found</div>
            }
            <RelatedPost tags={tags} postId={postId} />
          </>
        }
      </section>
    </>
  )
}